import { useFeatureFlag } from "~/composables/useFeatureFlag"

export async function usePageSlug() {
  let { slug } = useRoute().params
  const isPagePathEnabled = await useFeatureFlag("isPagePathEnabled")

  if (!slug)
    return { pageSlug: "" }

  // Normalize slug: filter out empty strings caused by trailing slashes
  if (Array.isArray(slug))
    slug = slug.filter(Boolean)

  if (isPagePathEnabled)
    return { pageSlug: Array.isArray(slug) ? slug.join("/") : slug }

  return { pageSlug: String(slug) }
}
